export default class FormForUser {
  constructor(formId, defaultSectionId, successSectionId, userEventName) {
    this.$form = $(formId);
    this.$defaultSection = $(defaultSectionId);
    this.$successtSection = $(successSectionId);
    this.userEventName = userEventName || this.$form.data('userEventName');

    this.bind();
  }

  bind() {
    if (this.$form.length && !this.$form.get(0).formForUserBound) {
      this.$form.on('submit', (e) => this.beforeSubmit(e));
      this.$form.get(0).formForUserBound = true;
    }
  }

  beforeSubmit(e) {
    e.preventDefault();

    const eventName = this.userEventName;
    const data = this.$form.serializeObject();

    UserTracker.emit('event',
      {
        eventName,
        data
      });

    this.showSuccess();
  }

  showSuccess() {
    this.$successtSection.removeClass('hidden');
    this.$defaultSection.addClass('hidden');
  }
}
